<div *ngIf="reportList else uagLoading">

  <p-table #rlTable [value]="reportList"
           [paginator]="paginator"
           [rows]="rows"
           [totalRecords]="totalRecords"
           [loading]="loading"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,25,50]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} записей"
           sortMode="single"
           [rowHover]="true"
           [resizableColumns]="true"
           selectionMode="single"
           [(selection)]="selectedReport"
           (onRowSelect)="onRowSelect($event)"
           (onRowUnselect)="onRowUnselect($event)"
           editMode="row"
           dataKey="REPORTID"
           stateStorage="local"
           stateKey="reportListTable-state"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped allow-overflow">

    <!--SELECT [REPORTID]
    ,[CLIID]
    ,[PERSID]
    ,[LCOCLIID]
    ,[DOCTYPE]
    ,[REPORTOPT]
    ,[REPORTNAME]
    ,[REPORTSERVER]
    ,[REPORTSRVOPT]

  cloneIndex?: number;
  DOCTYPENAME?: string;
  CLIENTNAME?: string;
  PERSONNAME?: string;

      -->

    <ng-template pTemplate="header">
      <tr>
        <th style="text-align:center; width:7rem">...</th>
        <th pSortableColumn="REPORTNAME" pResizableColumn width="10%">Печатная форма <p-sortIcon [field]="REPORTNAME"></p-sortIcon></th>
        <th pSortableColumn="REPORTSERVER" pResizableColumn width="15%">Сервер URI <p-sortIcon [field]="REPORTSERVER"></p-sortIcon></th>
        <th pSortableColumn="REPORTSRVOPT" pResizableColumn width="30%">Параметры отчета <p-sortIcon [field]="REPORTSRVOPT"></p-sortIcon></th>
        <th pSortableColumn="DOCTYPENAME" pResizableColumn width="10%">Тип документа <p-sortIcon [field]="DOCTYPENAME"></p-sortIcon></th>
        <th pSortableColumn="PERSONNAME" pResizableColumn width="10%">Пользователь <p-sortIcon [field]="PERSONNAME"></p-sortIcon></th>
        <th pSortableColumn="CLIENTNAME" pResizableColumn width="15%">Юрлицо <p-sortIcon [field]="CLIENTNAME"></p-sortIcon></th>
        <th pSortableColumn="REPORTOPT" pResizableColumn width="10%">Флаги <p-sortIcon [field]="REPORTOPT"></p-sortIcon></th>
      </tr>

      <tr *ngIf="true">
        <th>&nbsp;</th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по имени формы" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['REPORTNAME']" [class.filter-has-value]="cf3['REPORTNAME']" (input)="rlTable.filter($event.target.value, 'REPORTNAME', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по серверу" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['REPORTSERVER']" [class.filter-has-value]="cf3['REPORTSERVER']" (input)="rlTable.filter($event.target.value, 'REPORTSERVER', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по параметрам" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['REPORTSRVOPT']" [class.filter-has-value]="cf3['REPORTSRVOPT']" (input)="rlTable.filter($event.target.value, 'REPORTSRVOPT', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по документу" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['DOCTYPENAME']" [class.filter-has-value]="cf3['DOCTYPENAME']" (input)="rlTable.filter($event.target.value, 'DOCTYPENAME', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по пользователю" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['PERSONNAME']" [class.filter-has-value]="cf3['PERSONNAME']" (input)="rlTable.filter($event.target.value, 'PERSONNAME', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по юрлицу" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['CLIENTNAME']" [class.filter-has-value]="cf3['CLIENTNAME']" (input)="rlTable.filter($event.target.value, 'CLIENTNAME', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по параметрам" class="p-dropdown-filter-style"
                   [(ngModel)]="cf3['REPORTOPT']" [class.filter-has-value]="cf3['REPORTOPT']" (input)="rlTable.filter($event.target.value, 'REPORTOPT', 'contains')">
          </div>
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-report let-editing="editing" let-rii="rowIndex">
      <tr [pEditableRow]="report" [pSelectableRow]="report" >

        <td style="text-align:left">
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(report)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(report)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(report, rii)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="report.REPORTNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"/></ng-template>
            <ng-template pTemplate="output"><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{report.REPORTNAME}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="report.REPORTSERVER" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"/></ng-template>
            <ng-template pTemplate="output"><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{report.REPORTSERVER}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="report.REPORTSRVOPT" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"/></ng-template>
            <ng-template pTemplate="output"><input pInputText type="text" [(ngModel)]="report.REPORTSRVOPT" [style]="{'width':'100%'}" readonly (keydown)="$event.stopPropagation()"/></ng-template>
<!--            <ng-template pTemplate="output"><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{report.REPORTSRVOPT}}</div></ng-template>-->
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="fluid col">
                  <p-dropdown [options]="docTypes" optionLabel="DOCNAME1" [(ngModel)]="selectedDocType" dataKey="DOCTYPEID"
                              (onChange)="onDocTypeChange($event, report)" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
              </div>
            </ng-template>
            <ng-template pTemplate="output"><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{report.DOCTYPENAME}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="fluid">
                <div class="col">
                  <app-personselector [parentCompany]="report.CLIID" [selectedID]="report.PERSID" [showClear]="true"
                                      [showLabel]="false" (selectedPersonID)="mainPersonSelected($event, report)" [style]="{'width':'100%'}"></app-personselector>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="output"><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{report.PERSONNAME}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="fluid">
                <div class="col">
                  <app-companyselector [parentCompany]="report.CLIID" [selectedID]="report.LCOCLIID" (selectedCompanyID)="lcoCompanySelected($event, report)"
                                       [showLabel]="false" [showEditButton]="false" [showAddButton]="false" [showSearchButton]="false" [style]="{'width':'100%'}"></app-companyselector>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="output"><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{report.CLIENTNAME}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="report.REPORTOPT" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"/></ng-template>
            <ng-template pTemplate="output">{{report.REPORTOPT}}</ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid" *ngIf="allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                         [typeConfirmation]="typeDeleteConfirmation"
                                         [confirmText]="confirmText"
                                         (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Убрать все строки" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mt-2 mr-2" [disabled]="editMode || !selectedReport"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">нет данных для загрузки</td>
      </tr>
    </ng-template>

  </p-table>
</div>
<ng-template #uagLoading>
  <p>Информация загружается...</p>
</ng-template>

